var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-inquiry-container"},[_c('BaseStaffQrCode'),_c('Button',{attrs:{"depressed":"","color":"color-bnn","disabled":_vm.disabledButton,"loading":_vm.isLoading,"title":_vm.label},on:{"click":_vm.handleInquiryRequest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }